import { Row, Spinner, DropdownToggle, DropdownMenu } from 'reactstrap'
import styled, { css } from 'styled-components'
import { IconChevronDown, IconX } from '@tabler/icons-react'
//@ts-ignore
import { Avatar, Checkbox } from 'dsm-react-lib'

export type AlertStyleType = {
  [key: string]: {
    color: string
    backgroundColor: string
    hoverBackgroundColor: string
  }
}

export const SpinnerWrapper = styled(Row)<{ width?: string; height?: string }>`
  display: flex;
  justify-content: center;
  min-height: ${(props) => props.height || 'calc(100% - 3.45rem)'}; //footer height
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  align-content: center;
  gap: 10px;
  font-size: 1.3rem;
`

export const ButtonSpinner = styled(Spinner)`
  width: 1rem;
  height: 1rem;
  margin-right: 1rem;
`

export const alertStyles: AlertStyleType = {
  critical: {
    color: 'var(--color-critical)',
    backgroundColor: 'var(--chat-theme-secondary-light)',
    hoverBackgroundColor: 'var(--chat-theme-secondary-light)'
  },
  success: {
    color: 'var(--color-success-accent)',
    backgroundColor: 'var(--color-success-accent-light)',
    hoverBackgroundColor: 'var(--color-success-accent-light)'
  },
  warning: {
    color: 'var(--color-warning-dark)',
    backgroundColor: 'var(--color-warning-bg)',
    hoverBackgroundColor: 'var(--color-warning-bg)'
  },
  info: {
    color: 'var(--status-info-text)',
    backgroundColor: 'var(--status-info-bg)',
    hoverBackgroundColor: 'var(--status-info-bg)'
  }
}

export const NewDot = styled.span`
  border-radius: 50%;
  background-color: var(--color-success-accent);
  min-width: 1rem;
  height: 1rem;
  margin: 0.3rem 1rem 0 0;
  display: block;
  box-shadow: 0px 0px 0px 5px rgba(126, 189, 95, 0.1);
`

export const CloseBtn = styled(IconX)`
  cursor: pointer;
  color: ${(props) => props.color || 'white'};
  transition: transform 0.2s ease;
  &:hover {
    transform: scale(1.2);
  }
`

export const MiscWrapper = styled.div`
  display: flex;
  flex-basis: 100%;
  min-height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-bg);
  color: var(--text-heading);

  @media (max-width: 1650px) {
    zoom: 0.75;
  }

  .inner {
    position: relative;
    max-width: 750px;
    margin-top: 4rem;
    padding: 2rem;
    border-radius: 1rem;
  }

  h2 {
    color: var(--text-heading);
  }

  p {
    color: var(--text-body);
  }
`
export const BrandLogo = styled.a`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 2rem;
  left: 2rem;
  margin: 0;

  .brand-text {
    font-weight: 600;
  }
`

export const StyledDropdownToggle = styled(DropdownToggle)`
  padding: 0.5rem;
  cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
  color: var(--brand-accent-color);
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ isDisabled }) =>
    !isDisabled &&
    css`
      &:hover {
        border-radius: 50%;
        background-color: var(--brand-accent-bg);
      }
    `}
`

export const DropdownMenuContainer = styled(DropdownMenu)<{ $isCompact?: boolean }>`
  background-color: var(--surface-muted) !important;
  border: 1px solid var(--theme-border) !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 10px 24px var(--theme-shadow-color-soft) !important;
  overflow: hidden;
  padding: 0 !important;
  ${({ $isCompact }) =>
    $isCompact &&
    css`
      min-width: 0 !important;
      width: max-content !important;
      font-size: 0.8125rem !important;
    `}

  .dark &,
  .dark-layout &,
  body.dark-layout &,
  html.dark-layout & {
    background-color: var(--panel-surface-bg) !important;
    border-color: var(--frame-divider) !important;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.5) !important;
  }

  .dropdown-item {
    background-color: transparent !important;
    color: var(--text-heading) !important;
    display: flex;
    align-items: center;
    min-height: ${({ $isCompact }) => ($isCompact ? '30px' : '36px')};
    padding: ${({ $isCompact }) => ($isCompact ? '0.375rem 0.75rem' : '0.5rem 1rem')} !important;
    width: 100%;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
  }

  ${({ $isCompact }) =>
    $isCompact &&
    css`
      .dropdown-item > div {
        gap: 0.375rem !important;
      }
    `}

  .dropdown-item:hover,
  .dropdown-item:focus,
  .dropdown-item:active,
  .dropdown-item.active,
  .show > .dropdown-item {
    background-color: var(--nav-hover-bg) !important;
  }

  button {
    &:active {
      color: var(--text-heading) !important;
      background-color: var(--surface-muted-hover) !important;

      a {
        color: inherit !important;
      }

      h5 {
        color: var(--brand-accent-color) !important;
      }
    }
  }
`

export const UserAvatar = styled(Avatar)`
  cursor: default !important;
`
export const StyledChevron = styled(IconChevronDown)<{ $isCollapsed?: boolean }>`
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.$isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)')};
`
export const CustomInputWrapper = styled(Checkbox)`
  z-index: 0;
  display: inline-flex;
  word-break: break-word;
  label {
    font-size: 14px;
    font-weight: 400;
    margin-left: 7px;
  }
`
